import { call, select, put } from 'redux-saga/effects';


import API from "../../API";
import {validate} from "../login/utility";
import {addReportError, addReportSuccess, inputError, resetForm} from "./add-report-action-creators";
import {addNotificationRequest} from "../notifications/notifications-action-creators";

export default function* addReport() {

  const reportUrl = yield select(state => state.addReport.reportUrl);
  const name = yield select(state => state.addReport.name);
  const password = yield select(state => state.addReport.password);

  const reportUrlValid = yield call(validate, { input: reportUrl, action: inputError });
  const nameValid = yield call(validate, { input: name, action: inputError });
  const passwordValid = yield call(validate, { input: password, action: inputError });

  if (reportUrlValid && nameValid && passwordValid) {
    try {
      const result = yield call(API.addReport, {
        reportUrl: reportUrl.value,
        name: name.value,
        password: password.value
      });
      console.log(result, 'RESULT FROM ADD REPORT REQUEST');
      if (Object.keys(result.data).length) {
        yield put(addReportSuccess());
        yield put(addNotificationRequest({
          status: "Success",
          message: [
            `Title: ${result.data.title}`,
            `Response number: ${result.data.response_number}`,
            `Company: ${result.data.company}`
          ]
        }));
        yield put(resetForm())
      } else {
        yield put(addReportError());
        yield put(addNotificationRequest({status: "Error", message: ["Empty response..."]}));
      }
    } catch(error) {
      console.log(error, 'ERROR FROM ADD REPORT REQUEST');
      yield put(addReportError());
      yield put(addNotificationRequest({status: "Error", message: ["Something went wrong..."]}));
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/add-report/add-report-saga.js